<template>
  <div class="cont" v-if="showContent">
    <div class="logo">
      <img src="../assets/img/logo.png" alt="" width="73%" />
    </div>
    <div class="desc">
      您好，<br />
      欢迎来访『{{ comName }}』
    </div>
    <div :class="btnStyle">
      <van-button
        type="primary"
        block
        style="font-size: 15px;"
        @click="signIn"
        >{{ signText }}</van-button
      >
    </div>
    <div class="divide">
      <div class="divide-line"></div>
      报到后可使用
    </div>
    <noticeList :bg="bg" btnText="进入" @viewDetail="viewDetail"></noticeList>
    <van-dialog v-model="bindShow" title="请输入手机号绑定" confirmButtonColor="#009967" @closed="handleClosed" :before-close="handleConfirm" :close-on-click-overlay="hasPhone == 1">
      <div class="bind-input-class">
        <van-field border v-model="params.phone" placeholder="请输入11位手机号" />
      </div>
    </van-dialog>

    <van-dialog v-model="bindShowBand" title="磅单条形码" confirmButtonColor="#009967"  @opened="showBandOpened">
      <p v-if="bindShowBand" style="padding: 10px 0 0 0; text-align: center; color: red; font-size: 12px;">车牌号：{{  this.rowDataObj.report.license_plate}}</p>
      <p v-if="bindShowBand" style="padding: 10px 0 0 0; text-align: center; color: red; font-size: 12px;">{{ getBandCode() ? `磅单号：${getBandCode()}` : "暂无接收到磅单号，请稍等再打开尝试" }}</p>
      <div v-if="bindShowBand && getBandCode()" class="band-barcode" ref="barcode"></div>
    </van-dialog>
  </div>
</template>

<script>
// import { Toast } from "vant";
import noticeList from "../../../components/noticeList";

const CODE39_PATTERNS = {
  "0": "nnnwwnwnn",
  "1": "wnnwnnnnw",
  "2": "nnwwnnnnw",
  "3": "wnwwnnnnn",
  "4": "nnnwwnnnw",
  "5": "wnnwwnnnn",
  "6": "nnwwwnnnn",
  "7": "nnnwnnwnw",
  "8": "wnnwnnwnn",
  "9": "nnwwnnwnn",
  A: "wnnnnwnnw",
  B: "nnwnnwnnw",
  C: "wnwnnwnnn",
  D: "nnnnwwnnw",
  E: "wnnnwwnnn",
  F: "nnwnwwnnn",
  G: "nnnnnwwnw",
  H: "wnnnnwwnn",
  I: "nnwnnwwnn",
  J: "nnnnwwwnn",
  K: "wnnnnnnww",
  L: "nnwnnnnww",
  M: "wnwnnnnwn",
  N: "nnnnwnnww",
  O: "wnnnwnnwn",
  P: "nnwnwnnwn",
  Q: "nnnnnnwww",
  R: "wnnnnnwwn",
  S: "nnwnnnwwn",
  T: "nnnnwnwwn",
  U: "wwnnnnnnw",
  V: "nwwnnnnnw",
  W: "wwwnnnnnn",
  X: "nwnnwnnnw",
  Y: "wwnnwnnnn",
  Z: "nwwnwnnnn",
  "-": "nwnnnnwnw",
  ".": "wwnnnnwnn",
  " ": "nwwnnnwnn",
  $: "nwnwnwnnn",
  "/": "nwnwnnnwn",
  "+": "nwnnnwnwn",
  "%": "nnnwnwnwn",
  "*": "nwnnwnwnn"
};
export default {
  components: {
    noticeList
  },
  data() {
    return {
      tag: false, // 是否已报到
      btnStyle: "btn", // 立即报到按钮样式
      bg: [
        {
          img: require("../assets/img/route_bg.png"),
          title: "查看厂区平面图",
          color1: "#62E9C5",
          color2: "#3BC69E",
          route: "/rhwxRouteGuide",
          query: {
            map_type: "ht"
          }
        },
        {
          img: require("../assets/img/line_up_bg.png"),
          title: "查看当前排队情况",
          color1: "#AEBCE9",
          color2: "#79A1DA",
          route: "/rhwxQueueBoard",
          query: {}
        },
        {
          img: require("../assets/img/car_bg.png"),
          title: "阅读安全告知书",
          color1: "#FEC375",
          color2: "#F28E1E",
          route: "/rhwxNotice",
          query: {
            type: "success",
            map_type: "ht"
          }
        },
        {
          img: require("../assets/img/information_bg.png"),
          title: "绑定手机号",
          color1: "#98c4fa",
          color2: "#73a8fa",
          route: null,
          query: {
            type: "phone",
            map_type: "ht"
          }
        },
        {
          img: require("../assets/img/information_bg.png"),
          title: "磅单条形码",
          color1: "#98c4fa",
          color2: "#73a8fa",
          route: null,
          query: {
            type: "bandcode",
            map_type: "ht"
          }
        }
        
      ],
      signTag: 0, // 0为第一次报到，1为今日非首次报到
      signText: "",
      isSign: false, // 是否已报到
      isFirstSign: false, //是否为首次报到
      hasOnGoing: false, //是否有前置进行中的业务
      isInvalid: false, //是否报到失效
      rowDataObj: {},
      comName: "",
      showContent: false,
      bindShow: false,
      bindShowBand: false,
      params: {
        phone: ''
      },
      regular:  /\d{11}$/,
      hasPhone: 0 // 0为没绑定；1为存在绑定；
    };
  },
  mounted() {
    this.getDetail();
    this.getName();
  },
  created() {
    this.$common.http({
      url: '/api/pcenter/detail',
      data: {}
    }).then((res) => {
      if (res.data.errcode == 0) {
        if (!res.data.data.phone) {
          this.hasPhone = 0
          this.bindShow = true;
        } else {
          this.hasPhone = 1
        }
      }
    })
  },
  computed: {
    sub_com_id() {
      return this.$route.query.sub_com_id;
    },
    show_band_code(){
      return this.$route.query.show_band_code;
    },
  },
  methods: {
    // 获取当前可展示的磅单号，统一兼容接口空值场景。
    getBandCode() {
      const report = this.rowDataObj && this.rowDataObj.report ? this.rowDataObj.report : {};
      return String(report.qrcode || "").trim().toUpperCase();
    },

    // 弹层打开后渲染磅单条形码，司机端只保留条形码展示。
    showBandOpened(){
      const barcodeRef = this.$refs.barcode;
      const bandCode = this.getBandCode();
      if (!barcodeRef) {
        return;
      }
      // 先清空旧内容，避免多次打开弹层时重复叠加。
      barcodeRef.innerHTML = "";
      if (!bandCode) {
        return;
      }
      barcodeRef.innerHTML = this.buildCode39BarcodeSvg(bandCode);
    },

    // 将磅单号转换为 Code39 SVG，避免为单个展示场景再引入额外依赖。
    buildCode39BarcodeSvg(text) {
      const barcodeText = String(text || "").trim().toUpperCase();
      if (!barcodeText) {
        return "";
      }
      const encodedText = `*${barcodeText}*`;
      const narrowWidth = 2;
      const wideWidth = 6;
      const gapWidth = 2;
      const paddingX = 12;
      const barTop = 8;
      const barHeight = 72;
      let currentX = paddingX;
      const bars = [];

      for (const char of encodedText) {
        const pattern = CODE39_PATTERNS[char];
        if (!pattern) {
          return "";
        }
        for (let index = 0; index < pattern.length; index += 1) {
          const width = pattern[index] === "w" ? wideWidth : narrowWidth;
          // Code39 奇数位为黑条，偶数位为空白。
          if (index % 2 === 0) {
            bars.push(
              `<rect x="${currentX}" y="${barTop}" width="${width}" height="${barHeight}" fill="#000000" />`
            );
          }
          currentX += width;
        }
        currentX += gapWidth;
      }

      const svgWidth = currentX + paddingX;
      return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${svgWidth} 110" width="100%" height="110" aria-label="磅单条形码">
          <rect width="${svgWidth}" height="110" fill="#ffffff" />
          ${bars.join("")}
          <text x="${svgWidth / 2}" y="98" text-anchor="middle" font-size="16" fill="#000000" letter-spacing="2">${barcodeText}</text>
        </svg>
      `;
    },

    // 获取厂区名称
    getName() {
      this.$common
        .http({
          url: "/api/queue/summary/com_info",
          data: {
            com_id: this.sub_com_id
          }
        })
        .then(res => {
          console.log(res);
          this.comName = res.data.data.com_info.name;
          this.showContent = true;
        });
    },

    // 绑定手机号确认事件
    handleConfirm(action, done) {
      let phone = this.params.phone.trim()
      if (action === "confirm") {
        if (phone === "") {
          this.$common.mbToastFail("手机号不能为空");
          done(false);
        }else if (!this.regular.test(phone)) {
          this.$common.mbToastFail("手机号格式错误");
          done(false);
        } else {
          this.$common.http({
            url: '/api/pcenter/bind_phone',
            data: {
              phone
            }
          }).then(() => {
            done();
          }).catch(() => {
            done(false);
          })
        }
      } else {
        done();
      }
    },

    handleClosed() {
      this.params.phone = "";
    },

    // 查看详情
    viewDetail(route, query) {
      console.log(route, query);
      if (!route && query.type == "phone") {
        console.log('点击了绑定手机号')
        this.bindShow = true;
        return;
      }

      if (!route && query.type == "bandcode") {
        console.log('点击磅单条形码')
        this.bindShowBand = true;
        return;
      }
      this.btnStyle = "btn";
      // 今日未报到
      // if (!this.isSign || this.isInvalid) {
      // 1、立即报到 2、再次报到-已有业务  3、再次报到-正常报到 4、重新报到
      // 报到逻辑：
      // 1.1、前提：===2（已有业务）
      // 1.2、当前报到的厂区与访问的报到链接厂区不一致，提示其他厂区有正在进行中的业务
      // 1.3、否则，判断是否有排队信息，是否有安全告知书信息
      if (this.rowDataObj.report_state === 2) {
        if (this.rowDataObj.report.com_id === this.$route.query.sub_com_id) {
          if (route === "/rhwxQueueBoard") {
            // 当前无排队信息时，禁止司机查看
            if (
              Number(this.rowDataObj.report.is_input_queue) === 0 ||
              this.rowDataObj.business.length === 0
            ) {
              this.$common.mbToastFail("当前账号无排队信息");
              return false;
            } else if (Number(this.rowDataObj.report.booking_state) === 8) {
              this.$common.mbToastFail("车辆已离厂");
              return false;
            } else {
              this.$router.push({
                path: route,
                query: {
                  map_type: this.$route.query.map_type,
                  com_id: this.$route.query.com_id,
                  sub_com_id: this.$route.query.sub_com_id
                }
              });
            }
          } else if (route === "/rhwxNotice") {
            if (this.rowDataObj.safetyNotice.length === 0) {
              this.$common.mbToastFail("当前无排队安全告知书信息");
              return false;
            } else {
              this.$router.push({
                path: route,
                query: {
                  type: "success",
                  map_type: this.$route.query.map_type,
                  com_id: this.$route.query.com_id,
                  sub_com_id: this.$route.query.sub_com_id
                }
              });
            }
          } else {
            this.$router.push({
              path: route,
              query: {
                map_type: this.$route.query.map_type,
                com_id: this.$route.query.com_id,
                sub_com_id: this.$route.query.sub_com_id
              }
            });
          }
        } else {
          this.$common.mbToastFail("其它厂区有正在进行的业务");
          return false;
        }
      } else {
        // 2.1、前提： ===1、2、3（立即报到、正常报到、重新报到）
        // 2.2、可以正常报到
        // Toast({
        //   message: "请先报到",
        //   className: "toastEDE"
        // });
        this.$common.mbToastFail("请先报到");
        setTimeout(() => {
          this.btnStyle = "btn-animation";
        }, 2000);
      }
      // } else {
      //   this.$common.mbToastFail("其它厂区有正在进行的业务");
      //   return false;
      // }
    },

    // 报到
    signIn() {
      // if (this.isSign && this.hasOnGoing) {
      //   Toast({
      //     message: "请先完成前一次预约业务后再报到",
      //     className: "toastEDE"
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/rhwxCheckin/0"
      //   });
      // }
      if (this.rowDataObj.report_state === 2) {
        if (this.rowDataObj.report.com_id === this.$route.query.sub_com_id) {
          // Toast({
          //   message: "请先完成前一次预约业务后再报到",
          //   className: "toastEDE"
          // });
          this.$common.mbToastFail("请先完成前一次预约业务后再报到");
        } else {
          this.$common.mbToastFail("其它厂区有正在进行的业务");
        }
      } else {
        this.$router.push({
          path: "/rhwxCheckin/0",
          query: {
            map_type: this.$route.query.map_type,
            com_id: this.$route.query.com_id,
            sub_com_id: this.$route.query.sub_com_id
          }
        });
      }
    },

    // 获取报到详情
    getDetail() {
      this.$common
        .http({
          url: "/api/queue/driver/query_report_info",
          data: {
            com_id: this.$route.query.sub_com_id
          }
        })
        .then(res => {
          console.log(res);
          // 1 立即报到  2 再次报到-已有业务  3 再次报到-正常报到  4-重新报到
          this.rowDataObj = res.data.data;
          if (this.rowDataObj.report_state === 1) {
            this.signText = "立即报到";
          } else if (
            this.rowDataObj.report_state === 2 ||
            this.rowDataObj.report_state === 3
          ) {
            this.signText = "再次报到";
          } else if (this.rowDataObj.report_state === 4) {
            this.signText = "重新报到";
          } else {
            this.signText = "立即报到";
          }

          // this.rowDataObj.report.qrcode = "http://www.baidu.com";
          // 消息推进来，地址带上&show_band_code=1参数，自动打开
          if(this.show_band_code == 1){
            this.bindShowBand = true
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
.bind-input-class {
  width: 100%;
  margin: 0 auto;
  padding: 16px;
  box-sizing: border-box;
  .van-field {
    border: 1px solid #eee;
  }
}
.cont {
  padding: 16px;
  font-size: 16px;
  .logo {
    text-align: center;
    padding: 18px 27px 26px;
  }
  .desc {
    font-size: 25px;
    color: #333333;
    letter-spacing: 0.96px;
    line-height: 40px;
    padding-bottom: 6px;
    padding: 0px 17px;
  }
  .btn {
    padding: 22px 0px 30px;
  }
  .btn-animation {
    padding: 22px 0px 30px;
    animation: fade 1000ms 2;
    -webkit-animation: fade 1000ms 2;
  }
  .divide {
    opacity: 0.8;
    &-line {
      height: 16px;
      width: 4px;
      background: #009967;
      display: inline-block;
      vertical-align: text-top;
    }
  }
}

.band-barcode {
  display: flex;
  justify-content: center;
  padding: 10px 12px 16px;
}

@keyframes fade {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
  to {
    opacity: 1;
  }
}
@-webkit-keyframes fade {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fade {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
  to {
    opacity: 1;
  }
}
@-o-keyframes fade {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
  to {
    opacity: 1;
  }
}
@-ms-keyframes fade {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
  to {
    opacity: 1;
  }
}
</style>
